import { IonButton } from "@ionic/react";
import { useEffect, useState } from "react";
import { makeGETRequest, makePOSTRequest } from "../../request/rawRequest";

interface Props {
  idTheme: string;
  idComp: string;
  idVideo: string;
}

const getNextTheme = (idThemes: string[], idSearched: string): string => {
  let returnTheme = "";

  idThemes.forEach((theme, index, arr) => {
    if (theme === idSearched && arr[index + 1] !== undefined) {
      returnTheme = arr[index + 1];
    }
  });
  return returnTheme;
};

const NextTheme: React.FC<Props> = ({ idTheme, idComp, idVideo }) => {
  const [newHref, setNewHref] = useState<string>("");

  const getNextID = async () => {
    await makeGETRequest(
      "/skills/technology/unique?type=" +
        localStorage.getItem("techno") +
        "&pole=" +
        localStorage.getItem("pole")
    ).then((compArray) => {
      compArray.map(async (comp: any) => {
        if (comp._id === idComp) {
          // const idThemesReverse = comp.id_themes.sort((a: any, b: any) => {
          //   return a.localeCompare(b);
          // });

          const idNextTheme = getNextTheme(comp.id_themes, idTheme);
          if (idNextTheme === "") setNewHref("");
          else {
            await makePOSTRequest("/themes", { _id: idNextTheme }).then(
              (response) => {
                setNewHref(
                  `theme=${idNextTheme}&id=${response[0].id_videos[0]}&compID=${idComp}`
                );
              }
            );
          }
        }
      });
    });
  };

  useEffect(() => {
    getNextID();
  }, []);

  return (
    <IonButton
      style={{ fontSize: 20, width: "50%" }}
      shape="round"
      color="secondary"
      onClick={() => {
        window.location.href = "video?" + newHref;
      }}
      disabled={newHref.length <= 0}
    >
      Thème suivant
    </IonButton>
  );
};

export default NextTheme;
